define([
    'backbone'
], function() {
    var PagingCollection = Backbone.Collection.extend(
        /**
         * @lends PagingCollection.prototype
         */
        {
            _cursorNext: null,
            _cursorPrev: null,
            _numberFound: null,
            _page: null,
            _success: null,
            _error: null,
            _paging: null,

            /**
             * Paging 用の Collection です。
             *
             * extend して使って下さい。Paging 用の色々なメソッドの他に、
             * ページの切り替えが完了した時に発火される change:page という event が追加されています。
             * ページ番号やアイテム数、次ページの有無などを取得したい場合は上記 event を listen して下さい。
             *
             * @example
             * var UserCollection = PagingCollection.extend({
             *     model: User,
             *     url: '/api/users',
             *     limit: 10,
             *     doReset: true
             * });
             * ...
             * new UserCollection();
             * @constructs
             */
            initialize: function() {
                _.bindAll(this, 'success', 'error');
                this.listenTo(this, 'reset', this._removeModels);
            },

            _removeModels: function(collection, opts) {
                _.each(opts.previousModels, function(model){
                    model.trigger('remove');
                })
            },

            _buildUrl: function(queries) {
                var query_list = []
                _.each(queries, function(v, k){
                    if(!v) {
                        return;
                    }
                    query_list.push(k + '=' + v);
                })

                var url = (typeof(this.url) == 'function') ? this.url() : this.url;
                if(query_list.length > 0) {
                    url += '?' + query_list.join('&')
                }
                return url;
            },

            _fetch: function(options) {
                this._success = options.success ? options.success : null;
                options['success'] = this.success;

                this._error = options.error ? options.error : null;
                options['error'] = this.error;

                this._paging = options.paging ? options.paging : null;
                delete options.paging;

                return Backbone.Collection.prototype.fetch.call(this, options);
            },

            /**
             * Backbone.Collection.fetch のラッパー
             * nextPage や prevPage を呼ぶ前に fetch を呼ぶ必要があります。
             * @param options - Backbone.Collection.fetch を参照して下さい
             */
            fetch: function(options) {
                var url = this._buildUrl({
                    query: this.query,
                    limit: this.limit
                });

                options = _.extend({
                    url: url,
                    paging: _.bind(function(){
                        this._page = 1;
                    }, this)
                }, options)

                this._fetch(options);
            },

            /**
             * 次ページを取得します
             * 次ページが無い場合は何もせず return します。
             * @param options - Backbone.Collection.fetch を参照して下さい
             */
            nextPage: function(options) {
                if(!this._cursorNext) {
                    return;
                }
                var url = this._buildUrl({
                    query: this.query,
                    limit: this.limit,
                    cursor: this._cursorNext,
                    prev: 'false'
                });

                options = _.extend({
                    reset: this.doReset,
                    url: url,
                    paging: _.bind(function(){
                        this._page += 1;
                    }, this)
                }, options)

                this._fetch(options);
            },

            /**
             * 前ページを取得します
             * 前ページが無い場合は何もせず return します。
             * @param options - Backbone.Collection.fetch を参照して下さい
             */
            prevPage: function(options) {
                if(!this._cursorPrev) {
                    return;
                }

                var url = this._buildUrl({
                    query: this.query,
                    limit: this.limit,
                    cursor: this._cursorPrev,
                    prev: 'true'
                });

                options = _.extend({
                    reset: this.doReset,
                    url: url,
                    paging: _.bind(function(){
                        this._page -= 1;
                    }, this)
                }, options)

                this._fetch(options);
            },

            hasNext: function() {
                return this._cursorNext != null;
            },

            hasPrev: function() {
                return this._cursorPrev != null;
            },

            numberFound: function() {
                return this._numberFound;
            },

            /**
             * 現在のページを返します
             * ページは 1 から始まります。
             * まだ fetch されていない場合は null になります。
             */
            page: function() {
                return this._page;
            },

            /**
             * 総アイテム数のうち、何番目のものからが Collection に存在しているかを返します
             * まだ fetch されていない場合は null になります。
             */
            fromNum: function() {
                if(this._page == null) {
                    return null;
                }
                return this.limit * (this._page - 1) + 1;
            },

            /**
             * 総アイテム数のうち、何番目のものまでが Collection に存在しているかを返します
             * まだ fetch されていない場合は null になります。
             */
            toNum: function() {
                if(this._page == null) {
                    return null;
                }
                if(this.length < this.limit) {
                    return this.limit * (this._page - 1) + this.length;
                } else {
                    return this.limit * this._page;
                }
            },

            success: function(collection, response, options) {
                this._cursorNext = options.xhr.getResponseHeader('x-balus-cursor-next');
                this._cursorPrev = options.xhr.getResponseHeader('x-balus-cursor-prev');
                this._numberFound = options.xhr.getResponseHeader('x-balus-number-found');

                if(this._paging) {
                    this._paging(collection);
                }

                if(this._success) {
                    this._success.apply(this, arguments);
                }

                this.trigger('change:page');
            },

            error: function(collection, response, options) {
                //TODO
                console.log(response);

                if(this._error) {
                    this._error.apply(this, arguments);
                }
            }
        });

    return PagingCollection;
});



// WEBPACK FOOTER //
// ./common/domain/collection/paging.js